export const LoyaltyMode = {
  Full: 1,
  None: 2,
  EarnOnly: 3,
  RedeemOnly: 4
} as const;

export type LoyaltyModeValue = typeof LoyaltyMode[keyof typeof LoyaltyMode];

export const isLoyaltyEnabled = (mode: number | undefined): boolean => {
  if (mode === undefined || mode === null) return true;
  return mode !== LoyaltyMode.None;
};

export const canRedeemRewards = (mode: number | undefined): boolean => {
  if (mode === undefined || mode === null) return true;
  return mode === LoyaltyMode.Full || mode === LoyaltyMode.RedeemOnly;
};

export const canEarnStamps = (mode: number | undefined): boolean => {
  if (mode === undefined || mode === null) return true;
  return mode === LoyaltyMode.Full || mode === LoyaltyMode.EarnOnly;
};
